import axios from 'axios'

export default class TipoDocumento {
  constructor (tokenBearer, url) {
    this.url = url
    this.tokenBearer = tokenBearer
  }

  getTipoDocumento () {
    let url = `${this.url}/api/dominios/tipoDocumento`

    return new Promise(async (resolve, reject) => {
      let optionsTipoDocumento = {
        method: 'get',
        url,
        headers: {
          'Authorization': this.tokenBearer
        }

      }

      try {
        let responseTipoDocumento = await axios(optionsTipoDocumento)
        resolve(responseTipoDocumento)
      } catch (err) {
        reject(err)
      }
    })
  }
}
